//import axios from 'axios';

const state = {
  iconos: [
    { id: 1, nombre: "fa-square-root-alt" },
    { id: 2, nombre: "fa-calculator" },
    { id: 3, nombre: "fa-book" },
    { id: 4, nombre: "fa-atlas" },
    { id: 5, nombre: "fa-apple-alt" },
    { id: 6, nombre: "fa-book-reader" },
    { id: 7, nombre: "fa-vial" },
    { id: 8, nombre: "fa-flask" },
    { id: 9, nombre: "fa-landmark" },
    { id: 10, nombre: "fa-globe-americas" },
    { id: 11, nombre: "fa-globe" },
    { id: 12, nombre: "fa-running" },
    { id: 13, nombre: "fa-futbol" },
    { id: 14, nombre: "fa-church" },
    { id: 15, nombre: "fa-palette" },
    { id: 16, nombre: "fa-paint-brush" },
    { id: 17, nombre: "fa-brain" },
    { id: 18, nombre: "fa-chalkboard-teacher" },
    { id: 19, nombre: "fa-brain" },
    { id: 20, nombre: "fab fa-chromecast" },
    { id: 21, nombre: "fa-desktop" },
    { id: 22, nombre: "fa-divide" },
    { id: 23, nombre: "fa-dna" },
    { id: 24, nombre: "fa-edit" },
    { id: 25, nombre: "fab fa-envira" },
    { id: 26, nombre: "fa-euro-sign" },
    { id: 27, nombre: "fa-flag" },
    { id: 28, nombre: "fa-guitar" },
    { id: 29, nombre: "fa-handshake" },
    { id: 30, nombre: "fa-balance-scale" },
  ],
};

const getters = {};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
